<template>
  <div class="weui-msg inline-replacement">
    <div class="weui-msg__icon-area">
      <i :class="iconClass" />
    </div>
    <div class="weui-msg__text-area">
      <h2 class="weui-msg__title">{{ title }}</h2>
      <p class="weui-msg__desc">
        <slot name="desc">{{ desc }}</slot>
      </p>
    </div>
    <div class="weui-msg__opr-area">
      <p class="weui-btn-area">
        <slot />
      </p>
    </div>
    <div class="weui-msg__extra-area">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'success',
        },
        primary: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: null,
        },
        desc: {
            type: String,
            default: null,
        },
        visible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            iconClass: {
                [`weui-icon-${this.type}`]: true,
                [this.primary ? 'weui-icon_msg-primary' : 'weui-icon_msg']: true,
            },
        };
    },
};
</script>



// WEBPACK FOOTER //
// src/components/weui/msg/Index.vue